import React from 'react';
import { useWallet } from '../../context/WalletContext';
import { CURRENT_NETWORK } from '../../config/networks';

export default function WrongNetworkBanner() {
  const { account, wrongNetwork, requestSwitchNetwork, switching } = useWallet();
  if (!account || !wrongNetwork) return null;
  return (
    <div className="wrong-network-banner">
      <span>Wrong Network Connected</span>
      <button className="btn btn-danger btn-sm" onClick={requestSwitchNetwork} disabled={switching}>
        {switching ? <><span className="spinner" /> Switching</> : `Switch to ${CURRENT_NETWORK.name}`}
      </button>
    </div>
  );
}
